import { render } from "./vueComponentCloner.vue?vue&type=template&id=752f4b1e"
import script from "./vueComponentCloner.vue?vue&type=script&lang=js"
export * from "./vueComponentCloner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__